import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'

interface Options {
  query: string
  isDepotPayrole: boolean
}

export const apiDepotSearch = ({ query, isDepotPayrole }: Options) => {
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/ref/depots`,
    params: {
      search: query,
	  isDepotPayrole: isDepotPayrole ? true : false,
    }
  }
  return ax(options)
}